$(document).ready(function(){
  $('.co-toggle-accordion-trigger').click(function(){
    $(this).toggleClass('co-toggle-active').next('.co-toggle-item').slideToggle();
  });
})